import { Link } from 'react-router-dom'
import { UserDataChildrenContainer } from '../../../../../components/stories/organisms/top-navigation/styled-components'
import ContextMenuComponent from '../../../../../components/stories/organisms/context-menu'
import { contextMenuTitleWeightOptions } from '../../../../../components/stories/organisms/context-menu/constants'
import BadgesComponent from '../../../../../components/stories/atoms/badges'
import {
  badgeColorOptions,
  badgeSizeOptions,
  badgesVariantOptions
} from '../../../../../components/stories/atoms/badges/constants'
import ButtonComponent from '../../../../../components/stories/atoms/button'
import {
  buttonSizeOptions,
  buttonVariantOptions
} from '../../../../../components/stories/atoms/button/constants'
import { FormattedMessage, useIntl } from 'react-intl'
import { SpinnerGrey } from '../../../../../components/stories/atoms/icons/special'
import colorsOptions from '../../../../../components/stories/fundamentals/colors-styles/constants'
import { useStartTrialMutation } from '../../../../../react-query/authentication/mutations/use-start-trial-mutation'

const actionsOptions = {
  NONE: 'NONE',
  START_TEST: 'START_TEST',
  BUY: 'BUY',
  UPGRADE: 'UPGRADE'
}

const typeOptions = {
  FREE: 'FREE',
  TEST: 'TEST',
  PAID: 'PAID'
}

const UserLicense = ({ subscriptionData, isExpired, isLoading, endDate }) => {
  const { formatMessage } = useIntl()

  const { mutate: startTrialMutate, isPending } = useStartTrialMutation()

  if (isLoading) {
    return (
      <ContextMenuComponent.Item
        id="user-settings"
        trailingIcon={<SpinnerGrey size="icon-s" />}
      />
    )
  }

  const type = subscriptionData?.type
  const action = subscriptionData?.action
  const isTest = type === typeOptions.TEST
  const name = subscriptionData?.organisationSubscription?.tier?.name

  if (!type || !action || !name) {
    return null
  }

  const handleSecondaryText = () => {
    if (action !== actionsOptions.BUY) {
      return null
    }

    if (isExpired) {
      return (
        <span style={{ color: colorsOptions.secondaryColors.red.normal }}>
          {formatMessage({ id: `test_expired` })}
        </span>
      )
    }

    if (isTest) {
      return formatMessage(
        { id: 'valid_until' },
        { date: endDate?.toFormat('dd MMM yyyy') ?? '∞' }
      )
    }

    return null
  }

  const handleBadgeName = () => {
    if ((isTest && isExpired) || type === typeOptions.FREE) {
      return typeOptions.FREE.trim()?.toLowerCase()
    }

    return name?.trim()?.toLowerCase()
  }

  const handleBadgeColor = () => {
    if (action === actionsOptions.NONE || action === actionsOptions.UPGRADE) {
      return badgeColorOptions.DOCU_TOOLS_ORANGE
    }

    return badgeColorOptions.DOCU_TOOLS_DARK
  }

  // button handlers
  const handleButtonText = () => {
    if (action === actionsOptions.START_TEST) {
      return <FormattedMessage id="start_free_trial" />
    }

    return <FormattedMessage id="purchase" />
  }

  const handleButtonVariant = () => {
    if (isExpired) {
      return buttonVariantOptions.PRIMARY
    }

    return buttonVariantOptions['SECONDARY-HOLLOW']
  }

  const handleButtonAction = () => {
    if (action === actionsOptions.BUY) {
      return {
        to: 'https://docu-tools.com/preise/',
        target: '_blank',
        as: Link
      }
    }

    return {
      onClick: startTrialMutate
    }
  }

  const buttonConfig = {
    children: handleButtonText(),
    variant: handleButtonVariant(),
    ...handleButtonAction()
  }

  const dontShowButton =
    action &&
    (action === actionsOptions.NONE || action === actionsOptions.UPGRADE)

  return (
    <UserDataChildrenContainer>
      <ContextMenuComponent.Item
        id="user-settings"
        title={formatMessage({ id: 'userSettings_subscription' })}
        titleWeight={contextMenuTitleWeightOptions['TEXT-600']}
        secondaryText={handleSecondaryText()}
        badge={
          <BadgesComponent
            variant={badgesVariantOptions.HIGHLIGHTED}
            color={handleBadgeColor()}
            size={badgeSizeOptions.SMALL}
          >
            {handleBadgeName()}
          </BadgesComponent>
        }
        style={{
          pointerEvents: 'none'
        }}
      />

      {!dontShowButton && (
        <div style={{ width: '100%', padding: '0 0.5rem' }}>
          <ButtonComponent
            size={buttonSizeOptions.SMALL}
            fullWidth
            isLoading={isPending}
            {...buttonConfig}
          />
        </div>
      )}
      <ContextMenuComponent.Divider />
    </UserDataChildrenContainer>
  )
}

export default UserLicense
